import axiosConfig from '../../../../../config/axiosConfig';
import { Params } from '../../presenter/type/Presenter';

const CM0025_2Api = () => {
    const getReSummarySubmittedOutsourceCompanyOffsetCost = async (
        params: Params,
    ): Promise<any> => {
        try {
            const url = '/re-summary/submitted/outsource/company/offset-cost';
            const response = await axiosConfig.get(url, { params });
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    return {
        getReSummarySubmittedOutsourceCompanyOffsetCost,
    };
};

export default CM0025_2Api;
